import { StyleSheet, View } from 'react-native';
import { Icon, useTheme } from '@ui-kitten/components';

import Button from '../../../../Components/Button';
import Image from '../../../../Components/Image';
import { textCategory } from '../../../../Components/Reservation/constants';
import ResponsiveText from '../../../../Components/ResponsiveText';
import constants from '../../../../Config/constants';
import { capitalize, formatDistanceFromMeters } from '../../../../Helper';
import { StoreDetails } from '../../../../RTK/api/store/types';
import themeColor from '../../../../Theme/colors';
import themeStyle from '../../../../Theme/styles';

const ReservationCardBase = ({
  isSaved,
  name,
  distance,
  store_tags,
  partner_banner,
  toggleBookmark,
}: StoreDetails & { isSaved: boolean; toggleBookmark: () => void }) => {
  const theme = useTheme();
  return (
    <View style={themeStyle.spacingBottomMedium}>
      <View
        style={[
          themeStyle.flex1,
          themeStyle.flexDirectionRow,
          themeStyle.spacingBottomMedium,
        ]}
      >
        <View style={[themeStyle.flex1, themeStyle.spacingRightMedium]}>
          <ResponsiveText
            numberOfLines={1}
            category={textCategory.HEADING}
            style={themeStyle.bold}
          >
            {name}
          </ResponsiveText>
          <ResponsiveText
            category={textCategory.SMALL_BODY}
            numberOfLines={1}
            style={{ color: theme['color-primary-500'] }}
          >
            {formatDistanceFromMeters(distance)}
            {store_tags[0] ? ` ● ${capitalize(store_tags[0])}` : ''}
          </ResponsiveText>
        </View>
        <Button onPress={toggleBookmark} plain>
          <Icon
            pack="fa"
            name={isSaved ? 'bookmark' : 'bookmark-o'}
            fill={isSaved ? themeColor.violet : themeColor.black}
            style={{ width: 25, height: 25 }}
          />
        </Button>
      </View>
      <Image
        source={{ uri: partner_banner }}
        style={[styles.image, constants.isWeb && styles.safariImage]}
        resizeMode="cover"
      />
    </View>
  );
};

export const styles = StyleSheet.create({
  bookmarkIcon: {
    width: 30,
    height: 30,
  },
  image: {
    width: '100%',
    aspectRatio: 2.5 / 1,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  safariImage: {
    backfaceVisibility: 'hidden', // Forces GPU rendering
    willChange: 'transform',
  },
});

export default ReservationCardBase;
